import React from 'react';

import BaseLightboxContainer from './BaseLightboxContainer';

const MyStableLightboxContainer = () => (
  <BaseLightboxContainer
    type="mystable"
    title="My Stable"
    message="You'll need to sign in or register with My Stable to enable this feature."
  />
);

export default MyStableLightboxContainer;



// WEBPACK FOOTER //
// ./modules/Common/containers/Lightboxes/MyStableLightboxContainer.js